const unique = (value, index, self) => {
  return self.indexOf(value) === index
}

export const initializeCompletionStatus = () => {
  const traningElements = $('[data-traning]')

  if (traningElements.length > 0) {
    const interval = setInterval(function () {
      // let allCompleted = true
      let anyInProgress = false
      let anyNotCompleted = false
      const traningIds = []

      traningElements.each(function () {
        const element = $(this)
        const traningId = element.data('traning')
        traningIds.push(traningId)

        const successElement = element.find('.label--success')
        const elementNotCompleted = successElement.hasClass('grid-hidden')

        if (elementNotCompleted || successElement.length === 0) {
          anyNotCompleted = true
        }

        if (!!window.localStorage[traningId]) {
          if (elementNotCompleted === false) {
            // element is already a success, skip this one!
            return
          }
          anyInProgress = true
          successElement.addClass('grid-hidden')
          element.find('.label--danger').removeClass('grid-hidden')
        }
      })

      const showCompletedCourse = () => {
        clearInterval(interval)

        const ids = traningIds.filter(unique).sort()
        const completionId = `universal-robots-academy-completed-${ids.join('--')}`
        const video = $('#congratulations-video')

        // check if the id exists in localstore (i.e. the user has already seen the message)
        if (window.localStorage.getItem(completionId) !== 'shown') {
          window.localStorage.setItem(completionId, 'shown')
          $('#all-completed-modal').show()

          if (video.length > 0) {
            video[0].play()
          }
        }
      }

      // allCompleted = allCompleted && !anyInProgress
      const overallLabel = $('.overall-label.label--success')
      const skip = overallLabel.length > 0 && !overallLabel.hasClass('grid-hidden')
      if (skip) {
        // everything has already been completed
        showCompletedCourse()
        return
      }

      if (anyNotCompleted === false) {
        showCompletedCourse()
        $('.overall-label.label--success').removeClass('grid-hidden')
        $('.overall-label.label--danger').addClass('grid-hidden')
      } else if (anyInProgress) {
        $('.overall-label.label--success').addClass('grid-hidden')
        $('.overall-label.label--danger').removeClass('grid-hidden')
      } else {
        $('.overall-label.label--success').addClass('grid-hidden')
        $('.overall-label.label--danger').addClass('grid-hidden')
      }
    }, 1000)
  }
}
